// Torn Ink brand layer: scroll-reveal for homepage sections + a sakura-petal drift confined to the hero.
// Vanilla, dependency-free, respects prefers-reduced-motion. Hooked from snippets/scripts.liquid.

(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    const sections = document.querySelectorAll('main .shopify-section');
    if (!sections.length) return;

    // Sections are visible by default in CSS. Only opt them into the animated hidden
    // starting state once we're actually about to watch them, and always keep a hard
    // timeout that force-reveals every section — so a missed/slow/never-firing
    // IntersectionObserver callback can never leave real content permanently blank.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    sections.forEach((el) => el.classList.add('torn-ink-reveal'));

    const reveal = (el) => el.classList.add('is-visible');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach((el) => observer.observe(el));

    setTimeout(() => {
      sections.forEach(reveal);
      observer.disconnect();
    }, 2500);
  }

  function initSakuraPetals() {
    if (reduceMotion) return;

    const hero = document.getElementById('shopify-section-hero_rhMed7');
    if (!hero) return;

    const computedPosition = getComputedStyle(hero).position;
    if (computedPosition === 'static') hero.style.position = 'relative';

    const field = document.createElement('div');
    field.className = 'torn-ink-petals';
    field.setAttribute('aria-hidden', 'true');

    const PETAL_COUNT = 14;
    for (let i = 0; i < PETAL_COUNT; i++) {
      const petal = document.createElement('span');
      petal.className = 'torn-ink-petal';
      const size = 6 + Math.random() * 6;
      const fallDuration = 9 + Math.random() * 6;
      const swayDuration = 3 + Math.random() * 2;
      petal.style.left = `${Math.random() * 100}%`;
      petal.style.width = `${size}px`;
      petal.style.height = `${size}px`;
      petal.style.animationDuration = `${fallDuration}s, ${swayDuration}s`;
      petal.style.animationDelay = `${Math.random() * fallDuration}s, ${Math.random() * swayDuration}s`;
      field.appendChild(petal);
    }

    hero.appendChild(field);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollReveal();
      initSakuraPetals();
    });
  } else {
    initScrollReveal();
    initSakuraPetals();
  }
})();
